// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { FeaturedCategoryModel, getCategoriesData } from "@vanmeter/App/Services/CategoriesService";

type GetFeaturedCategoriesParameter = {
    numberOfCategoriesToReturn: number;
    categoriesList: string[];
    onSuccess?: (result: FeaturedCategoryModel[]) => void;
};

type HandlerType = ApiHandler<GetFeaturedCategoriesParameter, FeaturedCategoryModel[]>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getCategoriesData(props.apiParameter);
    } catch (error) {
        props.apiResult = [];
        logger.error(error);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameters, RequestDataFromApi, ExecuteOnSuccessCallback];

const loadFeaturedCategories = createHandlerChainRunner(chain, "loadFeaturedCategories");

export default loadFeaturedCategories;
